import { useAuth } from '../contexts/AuthContext';
import DashboardLayout from '../components/layout/DashboardLayout';
import WeeklySummary from '../components/WeeklySummary';

const Progress = () => {
    const { loading: authLoading } = useAuth();

    if (authLoading) {
        return (
            <DashboardLayout
                title="Your Progress"
                subtitle="Track your job search progress"
            >
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 'var(--space-4xl)',
                }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                          width: '48px',
                          height: '48px',
                          border: '3px solid var(--border-subtle)',
                          borderTop: '3px solid var(--indigo-500)',
                          borderRadius: '50%',
                          animation: 'spin 1s linear infinite',
                          margin: '0 auto var(--space-md)'
                        }} />
                        <p style={{ color: 'var(--text-tertiary)' }}>Loading your progress...</p>
                    </div>
                </div>
            </DashboardLayout>
        );
    }

    return (
        <DashboardLayout
            title="Your Progress"
            subtitle="Track your job search progress"
        >
            {/* Weekly Summary */}
            <div style={{ marginBottom: 'var(--space-2xl)' }}>
                <WeeklySummary />
            </div>
        </DashboardLayout>
    );
};

export default Progress;
